var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 38,
    viewBox: "0 0 75 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1341 25.1667L39.5833 15.6159L32.7214 22.4714C31.9076 23.2852 30.5924 23.2852 29.7786 22.4714L19.3602 12.0547C18.5466 11.2409 18.5466 9.92582 19.3602 9.11202C20.1738 8.29691 21.4928 8.29691 22.3066 9.11202L31.1914 18.0508L38.112 11.1953C38.9258 10.3815 40.2409 10.3815 41.0547 11.1953L52.0833 22.2175V16.7748C52.0833 15.681 53.0143 14.6914 54.1667 14.6914C55.319 14.6914 56.25 15.681 56.25 16.7748V27.25C56.25 28.4024 55.319 29.3334 54.1667 29.3334H43.75C42.5977 29.3334 41.6667 28.4024 41.6667 27.25C41.6667 26.0977 42.5977 25.1667 43.75 25.1667H49.1341Z",
    fill: "#B4003E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 33.3333,
    fill: "white",
    transform: "translate(18.75 2.25003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.5d9baa8b15e321a8e7cd0128cf88e653.svg";
export { ForwardRef as ReactComponent };